"use strict";

/* eslint-disable react/jsx-no-bind */
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var Preview =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Preview, _React$Component);

  function Preview() {
    (0, _classCallCheck2.default)(this, Preview);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Preview).apply(this, arguments));
  }

  (0, _createClass2.default)(Preview, [{
    key: "onChange",
    value: function onChange(evt) {
      this.props.onChange({
        hex: evt.target.value
      });
      evt.stopPropagation();
    }
  }, {
    key: "render",
    value: function render() {
      var hex = this.props.hex;
      return _react.default.createElement("div", {
        className: "private-react-colorpicker--preview"
      }, _react.default.createElement("span", {
        style: {
          backgroundColor: hex,
          opacity: this.props.alpha / 100
        }
      }), _react.default.createElement("input", {
        type: "color",
        defaultValue: hex,
        onChange: this.onChange.bind(this),
        onClick: this.props.onInputClick
      }));
    }
  }]);
  return Preview;
}(_react.default.Component);

exports.default = Preview;
Preview.propTypes = {
  hex: _react.default.PropTypes.string,
  alpha: _react.default.PropTypes.number,
  onChange: _react.default.PropTypes.func,
  onInputClick: _react.default.PropTypes.func
};
module.exports = exports.default;